// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"a9c9d034","703":"fba85e1f","787":"bef7a2a6"}[chunkId] + ".chunk.js";
};